import { Link } from "react-router-dom";
import useStoreSettings from "@/hooks/useStoreSettings";

export default function Footer() {
  const { lineUrl } = useStoreSettings();
  return (
    <footer className="bg-stone-900 text-white">
      <div className="px-6 lg:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://static.readdy.ai/image/823a8f074b021e82ba2884013917a5c5/a23db1fedd75cee41aae25a9154ab297.jpeg"
              alt="吉時國際貿易 跨境分銷平台"
              className="h-12 w-auto object-contain rounded mb-4"
            />
            <p className="text-stone-400 text-sm leading-relaxed mb-5">
              吉時國際貿易，專注跨境電商分銷，直連工廠貨源，助力分銷商零庫存輕鬆開店，賺取豐厚差價。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">快速導航</h4>
            <ul className="space-y-2.5">
              {[
                { label: "全部貨源", href: "/products", external: false },
                { label: "體驗認購區", href: "/products?region=體驗認購區", external: false },
                { label: "VIP認購區", href: "/products?region=VIP認購區", external: false },
                { label: "我的訂單", href: "/dashboard/orders", external: false },
                { label: "Line儲值", href: "https://line.me/ti/p/-xtd_8xuUf", external: true },
                { label: "分銷指南", href: "/guide", external: false },
              ].map((link) => (
                <li key={link.label}>
                  {link.external ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-stone-400 text-sm hover:text-amber-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      className="text-stone-400 text-sm hover:text-amber-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Distributor */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">分銷商服務</h4>
            <ul className="space-y-2.5">
              {[
                { label: "分銷商登入", href: "/login" },
                { label: "立即註冊", href: "/register" },
                { label: "個人中心", href: "/dashboard" },
                { label: "我的訂單", href: "/dashboard/orders" },
                { label: "儲值申請", href: "/dashboard/recharge" },
              ].map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-stone-400 text-sm hover:text-amber-400 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">聯絡我們</h4>
            <p className="text-stone-400 text-sm mb-4">聯繫團長：吉時小助手</p>
            <a
              href={lineUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#06C755] hover:bg-[#05b34d] text-white text-sm font-medium px-5 py-2.5 rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-line-fill text-base"></i>
              </div>
              立即私訊團長 (LINE)
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-stone-800 px-6 lg:px-12 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-500 text-xs">© 2025 吉時國際貿易 All Rights Reserved.</p>
          <div className="flex items-center gap-4">
            {["隱私政策", "使用條款", "分銷協議"].map((item) => (
              <a key={item} href="#" className="text-stone-500 text-xs hover:text-amber-400 transition-colors cursor-pointer">
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
